<template>
  <section class="section-about-landing">
    <div class="u-center-text u-margin-bottom-big">
      <h2 class="heading-secondary">Veterinary + Machine Learning</h2>
    </div>

    <div class="row">
      <div class="col-1-of-2">
        <div class="about__images">
          <div class="img-gradient">
            <img
              src="@/assets/imgs/about_robot.webp"
              alt="About Robot"
              class="composition__photo composition__photo--p4 nohover"
            />
          </div>
        </div>
      </div>
      <div class="col-1-of-2">
        <h3 class="heading-tertiary u-margin-top-medium u-margin-bottom-small">
          Machine Learning is rapidly evolving
        </h3>
        <p class="paragraph">Computer Vision or Natural Language Processing</p>
        <h3 class="heading-tertiary u-margin-bottom-small">
          Got an exciting idea (or data?)
        </h3>
        <p class="paragraph">
          Contact me to find out how I can help, I have liased with multiple
          companies and institutions on how to utilise machine learning in a
          medical field.
        </p>

        <h3 class="heading-tertiary u-margin-bottom-small">
          Interested in Applying it to Veterinary Medicine?
        </h3>
        <p class="paragraph">
          Check out some of the blog posts, and tutorials that I have written
          which apply Machine Learning to Veterinary Medicine
        </p>

        <router-link class="btn-text" :to="{ name: 'Blog' }">
          Check out Blog Posts &rarr;
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About'
}
</script>
